import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import OpcoesFiltroPor from "./OpcoesFIltroPor";
import ButtonHandle from "./ButtonHandle";
import MonthYearPicker from "../../../../../components/MonthYearPicker";
import ConvertDataService from '../../../../../services/util/ConvertDatas';


/**
 * Mordal de filtros
 *
 * @param {string} buttonHandle - Passar o nome do modal para definir os dados a serem retornados ao enviar o form.
 * @param {Object} clientes - Passar lista de clientes.
 * @param {Object} projetos - Passar lista de projetos.
 * @param {boolean} habilitarTipoCusto - Ao passar true, exibe o campo de seleção de tipo de custo.
 * @param {boolean} habilitarMultiSelect - Ao passar true, exibe o select do tipo multiplo para seleção de projetos.
 * @param {boolean} habilitarDataMeses - Ao passar true, muda para o formato de data por meses, false muda para somente o ano.
 * @param {boolean} habilitarRadioTotalOuData - Ao passar true, exibe o radio de total ou data, false existe somente a data.
 * @returns Componente do modal usada no filtro da pagina Relatorio Delivery.
 */

export default function ModalFiltros(props) {
    const [clienteSelecionado, setClienteSelecionado] = useState("default");
    const [clienteLabel, setClienteLabel] = useState("Cliente não cadastrado");
    const [dataFinal, setDataFinal] = useState(new Date());
    const [dataInicial, setDataInicial] = useState(new Date());
    const [liderSelecionado, setLiderSelecionado] = useState("default");
    const [projetosSelecionados, setProjetosSelecionados] = useState("default");
    const [radioFiltrarPor, setRadioFiltrarPor] = useState('default');
    const [radioPeriodo, setRadioPeriodo] = useState('default');
    const [tipoCusto, setTipoCusto] = useState('');
    const [anoSelecionado, setAnoSelecionado] = useState("");

    useEffect(() => {
        setClienteSelecionado("");
        setClienteLabel("");
        setLiderSelecionado("");
        setProjetosSelecionados();
        setTipoCusto("");
    }, [radioFiltrarPor]);

    useEffect(() => { 
        setLiderSelecionado("default");
        setProjetosSelecionados("default");
        setClienteSelecionado("default");
        setClienteLabel("Cliente não cadastrado")
    },[radioFiltrarPor])

    useEffect(() => {setAnoSelecionado("total")},[radioPeriodo])

    const handleRadioFiltrarPor = (event) => {
        setRadioFiltrarPor(event.target.value);
    };

    const handleRadioPeriodo = (event) => {
        setRadioPeriodo(event.target.value);
    };

    return (
        <>
            <span style={{ fontSize: "12px" }}>* Campo obrigatório</span>
            <Form className="mt-3">
                {props.habilitarRadioTotalOuData && (
                    <Form.Group>
                        <Form.Label>Período: *</Form.Label>
                        <Form.Check
                            type="radio"
                            label="Total"
                            name="radioGroupPeriodo"
                            id="por-total"
                            value="total"
                            checked={radioPeriodo === 'total'}
                            onChange={handleRadioPeriodo}
                        />
                        <Form.Check
                            type="radio"
                            label="Data/Ano"
                            name="radioGroupPeriodo"
                            id="por-data"
                            value="data"
                            checked={radioPeriodo === 'data'}
                            onChange={handleRadioPeriodo}
                        />
                    </Form.Group>
                )}

                {(!props.habilitarRadioTotalOuData || radioPeriodo === 'data') && (
                    <>
                        {props.habilitarDataMeses ? (
                            <div className='d-flex'>
                                <Form.Group className='d-flex flex-column mr-3'>
                                    <Form.Label>Período inicial: </Form.Label>
                                    <MonthYearPicker setMonthYear={setDataInicial} monthYear={dataInicial} />
                                </Form.Group>
                                <Form.Group className='d-flex flex-column mr-3'>
                                    <Form.Label>Período final: </Form.Label>
                                    <MonthYearPicker setMonthYear={setDataFinal} monthYear={dataFinal} />
                                </Form.Group>
                            </div>
                        ) : (
                            <Form.Group className='mr-3'>
                                <Form.Label>Ano</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="ano"
                                    onChange={(e) => setAnoSelecionado(e.target.value)}
                                >
                                    <option value="">Selecione</option>

                                    {ConvertDataService.getAnos().map(ano => (
                                        <option key={ano} value={ano}>{ano}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        )}
                    </>
                )}

                <Form.Group>
                    <Form.Label>Filtrar por: *</Form.Label>
                    <Form.Check
                        type="radio"
                        label="Cliente"
                        name="radioGroup"
                        id="por-cliente"
                        value="cliente"
                        checked={radioFiltrarPor === 'cliente'}
                        onChange={handleRadioFiltrarPor}
                    />
                    <Form.Check
                        type="radio"
                        label="Projeto"
                        name="radioGroup"
                        id="por-projeto"
                        value="projeto"
                        checked={radioFiltrarPor === 'projeto'}
                        onChange={handleRadioFiltrarPor}
                    />
                    <Form.Check
                        type="radio"
                        label="Líder"
                        name="radioGroup"
                        id="por-lider"
                        value="líder"
                        checked={radioFiltrarPor === 'líder'}
                        onChange={handleRadioFiltrarPor}
                    />
                </Form.Group>

                <OpcoesFiltroPor
                    clientes={props.clientes}
                    projetos={props.projetos}
                    lideres={props.lideres}
                    radioFiltrarPor={radioFiltrarPor}
                    clienteSelecionado={clienteSelecionado}
                    setClienteSelecionado={setClienteSelecionado}
                    clienteLabel={clienteLabel}
                    setClienteLabel={setClienteLabel}
                    liderSelecionado={liderSelecionado}
                    setLiderSelecionado={setLiderSelecionado}
                    habilitarMultiSelect={props.habilitarMultiSelect}
                    projetosSelecionados={projetosSelecionados}
                    setProjetosSelecionados={setProjetosSelecionados}
                />

                {(props.habilitarTipoCusto ?? false) && (
                    <Form.Group>
                        <Form.Label>Selecione o tipo de custo: *</Form.Label>
                        <Form.Control
                            as="select"
                            name="tipoCusto"
                            value={tipoCusto}
                            onChange={(e) => { setTipoCusto(e.target.value) }}
                        >
                            <option value="">--Selecionar Custo--</option>
                            <option value="INFRA_CLOUD">Infraestrutura em Cloud</option>
                            <option value="OUTROS_SOFTWARES">Outros softwares</option>
                            <option value="HORAS_EXTRAS">Horas extras</option>
                            <option value="FORNECEDORES_TERCEIROS">Fornecedores terceiros</option>
                            <option value="OUTROS">Outros</option>
                            <option value="VALOR_HH">Valor HH</option>
                            <option value="total">Total</option>
                        </Form.Control>
                    </Form.Group>
                )}

                <ButtonHandle
                    handleDados={props.handleDados}
                    buttonHandle={props.buttonHandle}
                    projetosSelecionados={projetosSelecionados}
                    radioFiltrarPor={radioFiltrarPor}
                    dataInicial={dataInicial}
                    dataFinal={dataFinal}
                    tipoCusto={tipoCusto}
                    clienteSelecionado={clienteSelecionado}
                    clienteLabel={clienteLabel}
                    liderSelecionado={liderSelecionado}
                    anoSelecionado={anoSelecionado}
                    radioPeriodo={radioPeriodo}
                />
            </Form>
        </>
    );
}